module.exports = __webpack_public_path__ + "img/north-macedonia.2bad1651.svg";